export default {
    palette: {
        type: 'light',
        primary: {
            main: '#21355B',
        },
        secondary: {
            main: '#F9A738',
        },
    }
}